const HOURS = [
  { day: 'Segunda-feira', time: '08h – 18h' },
  { day: 'Terça-feira',   time: '08h – 18h' },
  { day: 'Quarta-feira',  time: '08h – 18h' },
  { day: 'Quinta-feira',  time: '08h – 18h' },
  { day: 'Sexta-feira',   time: '08h – 17h' },
  { day: 'Sábado',        time: 'Fechado' },
  { day: 'Domingo',       time: 'Fechado' },
];

const INFO_ITEMS = [
  {
    icon: 'ri-map-pin-2-line',
    label: 'Endereço',
    lines: ['Florianópolis – SC', 'Consulte pelo WhatsApp para o endereço completo'],
  },
  {
    icon: 'ri-whatsapp-line',
    label: 'Celular / WhatsApp',
    lines: ['(48) 99100-2443'],
    href: 'https://wa.me/5548991002443',
    external: true,
  },
  {
    icon: 'ri-mail-line',
    label: 'E-mail',
    lines: ['contato@dralaurafolchini.com.br'],
    href: 'mailto:contato@dralaurafolchini.com.br',
  },
  {
    icon: 'ri-instagram-line',
    label: 'Instagram',
    lines: ['@dralaurafolchini'],
    href: 'https://www.instagram.com/laurafolchini/',
    external: true,
  },
];

export default function ContactInfo() {
  const today = new Date().getDay();

  return (
    <div className="flex flex-col gap-5">
      {/* Info cards */}
      <div className="bg-white rounded-2xl border border-[#E8DCC8] p-5 sm:p-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#FBF8F3] rounded-full mb-5">
          <div className="w-1.5 h-1.5 bg-[#C4A57B] rounded-full" />
          <span className="text-xs text-[#8B7355] font-medium">Informações do Consultório</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {INFO_ITEMS.map((item) => (
            <div key={item.label} className="flex items-start gap-3">
              <div className="w-9 h-9 bg-[#FBF8F3] rounded-full flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-[#C4A57B] text-base`} />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-medium text-[#B8A898] mb-0.5">{item.label}</p>
                {item.href ? (
                  <a
                    href={item.href}
                    target={item.external ? '_blank' : undefined}
                    rel={item.external ? 'noopener noreferrer' : undefined}
                    className="text-sm text-[#4A3F35] hover:text-[#C4A57B] transition-colors cursor-pointer break-all"
                  >
                    {item.lines[0]}
                  </a>
                ) : (
                  item.lines.map((line, i) => (
                    <p key={i} className="text-sm text-[#4A3F35] leading-relaxed">{line}</p>
                  ))
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Hours */}
      <div className="bg-[#FBF8F3] rounded-2xl border border-[#E8DCC8] p-5 sm:p-7">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-9 h-9 bg-white rounded-full flex items-center justify-center flex-shrink-0">
            <i className="ri-time-line text-[#C4A57B] text-base" />
          </div>
          <div>
            <p className="text-xs text-[#B8A898] font-medium">Horário de Atendimento</p>
            <p className="text-sm font-medium text-[#4A3F35]">Segunda a Sexta</p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1">
          {HOURS.map((h, idx) => {
            const isClosed = h.time === 'Fechado';
            const isToday = idx + 1 === today || (idx === 6 && today === 0);
            return (
              <div
                key={h.day}
                className={`flex justify-between items-center py-1.5 px-3 rounded-lg text-sm
                  ${isToday ? 'bg-[#C4A57B]/10 border border-[#C4A57B]/30' : 'border border-transparent'}
                `}
              >
                <span className={`text-xs ${isToday ? 'text-[#8B6040] font-medium' : 'text-[#8B7355]'}`}>
                  {h.day}
                  {isToday && (
                    <span className="ml-1.5 text-[10px] bg-[#C4A57B] text-white px-1.5 py-0.5 rounded-full">
                      Hoje
                    </span>
                  )}
                </span>
                <span className={`text-xs ${isClosed ? 'text-[#B8A898]' : isToday ? 'text-[#8B6040] font-medium' : 'text-[#4A3F35]'}`}>
                  {h.time}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {/* Maps — lado a lado */}
      <div className="grid grid-cols-2 gap-3">
        {[
          {
            city: 'Criciúma',
            clinic: 'KASA DERMA',
            src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55234.89537800842!2d-49.42!3d-28.68!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDQwJzQ4LjAiUyA0OcKwMjUnMTIuMCJX!5e0!3m2!1spt-BR!2sbr!4v1234567890',
          },
          {
            city: 'Tubarão',
            clinic: 'Grupo Naiana SA',
            src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55234.89537800842!2d-49.01!3d-28.47!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDI4JzEyLjAiUyA0OcKwMDAnMzYuMCJX!5e0!3m2!1spt-BR!2sbr!4v1234567890',
          },
        ].map(({ city, clinic, src }) => (
          <div key={city} className="bg-white rounded-xl overflow-hidden border border-[#E8DCC8]">
            <div className="px-3 pt-3 pb-2">
              <p className="text-sm font-medium text-[#4A3F35] leading-tight">{city}</p>
              <p className="text-xs text-[#8B7355] truncate">{clinic}</p>
            </div>
            <div className="h-36 sm:h-44">
              <iframe
                src={src}
                title={`Mapa ${city}`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
